/**
 * Core type for any text that exists in both Arabic and English.
 * Stored as JSONB in Postgres.
 */
import { z } from "zod";

export const bilingualStringSchema = z.object({
	ar: z.string().min(1),
	en: z.string().optional(),
});

export type BilingualString = z.infer<typeof bilingualStringSchema>;

export type Language = "ar" | "en";
export type Direction = "rtl" | "ltr";

export const LANGUAGES: readonly Language[] = ["ar", "en"] as const;
export const DIRECTIONS: Record<Language, Direction> = {
	ar: "rtl",
	en: "ltr",
};

/** Get string in preferred language, fallback to other if missing. */
export function getLocalized(
	value: BilingualString | null | undefined,
	lang: Language,
): string {
	if (!value) return "";
	const primary = value[lang];
	if (primary) return primary;
	const fallback = lang === "ar" ? value.en : value.ar;
	return fallback ?? "";
}
